import { captureMessage } from '@sentry/browser'
import { ReactIntlErrorCode } from 'react-intl'

const report = ( process.env.NODE_ENV === 'production' ) ? captureMessage : console.error


export default function onError(error) {
  // A missing translation is non-actionable: react-intl falls back to
  // the source message, so the user still sees correct text. These
  // fire in high volume — from adhoc, provider-localized error strings
  // that can never have a catalog entry, and from stale bundles served
  // to cached clients — so we drop them rather than flood Sentry. The
  // `test:i18n` gate is what catches genuinely absent keys, at build
  // time.
  if ( error?.code === ReactIntlErrorCode.MISSING_TRANSLATION ) {
    return
  }

  report(error)
}
